/* 
Common code for each of the views making up the invoice page.
*/
import * as action from "@/store/invoices/action-types";

export default {
  computed: {
    invoiceId() {
      return parseInt(this.$route.params.id);
    },
    levyCollectionId() {
      return this.arrivedFromLevyCollection ? parseInt(this.$route.params.levyCollectionId) : null;
    },
    nextPageAction() {
      return action.LIST_NEXT_PAGE;
    },
    previousPageAction() {
      return action.LIST_PREVIOUS_PAGE;
    },
    arrivedFromLevyCollection() {
      return this.$route.path.includes("/levy-collections/");
    },
    arrivedFromProvider() {
      return this.$route.path.includes("/providers/");
    },
    breadcrumbs() {
      if (this.invoice == null) {
        return [{ text: "..." }];
      }
      if (this.arrivedFromLevyCollection) {
        return [
          {
            text: `${this.invoice.levyCollection} levy collection invoices`,
            path: `/levy-collections/${this.invoice.levyCollectionId}/invoices`
          },
          { text: `Invoice ${this.invoice.sapDocumentIdentifier}` }
        ];
      }
      if (this.arrivedFromProvider) {
        return [
          { text: "Providers", path: "/providers" },
          { text: this.invoice.provider, path: `/providers/${this.invoice.providerId}/invoices` },
          { text: `Invoice ${this.invoice.sapDocumentIdentifier}` }
        ];
      }
      return [{ text: "Invoices", path: "/invoices" }, { text: `Invoice ${this.invoice.sapDocumentIdentifier}` }];
    },
    state() {
      return this.$store.state.invoices.view;
    },
    invoice() {
      return this.state.data;
    },
    loaded() {
      return this.state.loaded;
    },
    loading() {
      return this.state.loading;
    },
    title() {
      return this.invoice.sapDocumentIdentifier ? `Invoice ${this.invoice.sapDocumentIdentifier}` : "";
    },
    subtitle() {
      return this.invoice.provider ? this.invoice.provider : "";
    }
  },
  mounted() {
    this.reload();
  },
  watch: {
    invoiceId() {
      this.reload();
    },
    loaded() {
      this.reload();
    },
    loadedProviderTasks() {
      this.reload();
    }
  },
  methods: {
    reload() {
      this.$store.dispatch(action.VIEW_REFRESH, this.invoiceId);
    },
    getNavUrl(suffix) {
      if (this.arrivedFromLevyCollection) return null;
      if (this.arrivedFromProvider) return `/providers/${this.invoice.providerId}/invoices/:id/${suffix}`;
      return `/invoices/:id/${suffix}`;
    }
  }
};
